<template>
  <div class="container">
    <div class="content">
      <SelectedStore
        :selected-store-id="shopId"
        @create-zone="createZone"
        @edit-zone="editZone"
        @remove-zone="deleteZone"
      />
    </div>
    <AddStoreModal
      :is-open="addModal"
      @close="addModal = false"
    />
    <keep-dom-dialog v-model="areaDialogShow" @close="clearZoneComponent">
      <div id="module-area" />
    </keep-dom-dialog>
    <confirm-dialog
      ref="confirmDialog"
      :open="confirm"
      @cancel="confirm = false"
    />
  </div>
</template>

<script>
/**
 * Корневой Vue компонент модуля PageRegularDelivery
 * @module PageShop/Component/App
 * @requires vuex
 * @requires PageShop/store
 * @requires Images/icon/ic-add.svg
 * @requires PageShop/components/Stores
 * @requires PageShop/components/SelectedStore
 * @requires PageShop/components/AddStoreModal
 * @listens module:Shared/Component/KeepDomDialog#close
 * @listens module:Shared/Component/ConfirmDialog#answer
 * @listens module:Shared/Component/ConfirmDialog#cancel
 * @vue-data {Boolean} addModal - состояние модального окна добавления магазина
 * @vue-data {SVG} icAdd - Иконка добавления магазина
 * @vue-data {Boolean} areaDialogShow - Открыт диалог создания/редактирования зоны
 * @vue-data {Boolean} openAreaInModal - Создание/редактирование зоны происходит в модальном окне
 *   Альтернатива - переход на страницу создания/редактирования
 * @vue-data {Boolean} confirm - Открыт диалог подтверждения
 * @vue-computed {String} shopId - id выбранного магазина
 */
import store from 'PageShop/store'
import { mapActions, mapState, mapMutations } from 'vuex'
import icAdd from 'Images/icon/ic-add.svg'
import SelectedStore from 'PageShop/components/SelectedStore'
import AddStoreModal from 'PageShop/components/AddStoreModal'
import KeepDomDialog from 'Shared/KeepDomDialog'
import ConfirmDialog from 'Shared/ConfirmDialog'

export default {
  name: 'PageShop',
  components: {
    SelectedStore,
    AddStoreModal,
    KeepDomDialog,
    ConfirmDialog
  },
  props: {
    shopId: String
  },
  store,
  data: () => ({
    /**
     * Состояние модального окна
     * @type {Boolean}
     * */
    addModal: false,
    /**
     * Иконка добавления магазина
     * @type {SVG}
     * */
    icAdd,
    /**
     * Открыт диалог создания/редактирования зоны
     * @type {Boolean}
     * */
    areaDialogShow: false,
    /**
     * Создание/редактирование зоны происходит в модальном окне
     * Альтернатива - переход на страницу создания/редактирования
     * @type {Boolean}
     * */
    openAreaInModal: false,
    /**
     * Открыт диалог подтверждения
     * @type {Boolean}
     * */
    confirm: false
  }),
  computed: {
    ...mapState(['regularDelivery']),
    /**
     * Экземпляр модуля PageArea
     * Создать обычну перменную на уровне модуля не получтся
     * т.к. появляется асинхронно к моменту хука beforeCreate
     * */
    //pageAreaModule: () => new PageArea()
  },
  async created() {
    if (!this.shopId) {
      await this.$router.push('/not-found')
    }
    //this.pageAreaModule.$$on('submit', this.onZoneSubmit)
    //this.setShopId(this.shopId)
  },
  methods: {
    ...mapActions('storeModule/zonesModule', ['removeZone', 'getZones']),
    //...mapMutations(['setShopId']),
    /**
     * Редактировать зону доставки
     * @fires module:PageArea#create
     * */
    createZone() {
      if (this.openAreaInModal) {
        this.areaDialogShow = true
        /*this.pageAreaModule.$$emit('create', {
          shopId: this.shopId
        })*/
      } else {
        this.$router.push({path:'/create-area', query:{shopId: this.shopId}});
      }
    },

    /**
     * Удалить зону доставки
     * @param {String} zoneId
     * @listens module:Shared/Component/ConfirmDialog#answer
     * */
    async deleteZone(zoneId) {
      this.confirm = true
      this.$refs.confirmDialog.$once('answer', val => {
        if (val === 'confirm') this.removeZone(zoneId)
        this.confirm = false
      })
    },

    /**
     * Редактировать зону доставки
     * @fires module:PageArea#edit
     * */
    editZone(zone) {
      if (this.openAreaInModal) {
        this.areaDialogShow = true
        /*this.pageAreaModule.$$emit('edit', {
          shopId: this.shopId,
          areaId: zone.id
        })*/
      } else {
        this.$router.push({path:`/area/${zone.id}`, query:{shopId: this.shopId}})
      }
    },

    /**
     * Сбросить компонент создания/редактирования зон доставки
     * @fires module:PageArea#clear
     * @listens module:Shared/Component/KeepDomDialog#close
     * */
    clearZoneComponent() {
      this.areaDialogShow = false
      //this.pageAreaModule.$$emit('clear')
    },

    /**
     * Обоаботчик на успешное сохранение зоны доставки
     * @listens module:PageArea#submit
     * @fires module:PageArea#clear
     * */
    onZoneSubmit() {
      this.clearZoneComponent()
      this.getZones(this.shopId)
    }
  }
}
</script>

<style lang="scss" scoped>
#content {
  width: 100%;
  height: 100%;
  position: relative;
}

.content {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .left {
    padding: 25px;

    border-right: 1px solid rgba(gray, 0.5);

    display: flex;
    flex-direction: column;
  }

  .subtitle {
    font-size: 18px;
    font-weight: 600;
  }

  .element {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .stores-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      position: relative;
      margin-left: 20px;

      width: 36px;
      height: 36px;

      border-radius: 36px;

      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
#module-area {
  padding: 0;
}
</style>
